<template>
  <profile class="userprofile" :options="options">
    <template #header>
      <div id="welcome_row">
        <div class="mainWrap mt-5">
          <div class="row">
            <div class="col-6 col-sm-6">
              <h1 class="h1-white">
                Welcome,<br />
                {{
                  getFirstNameAndLastName()
                    ? getFirstNameAndLastName()
                    : userStore.authUser?.userName
                }}
              </h1>
            </div>
            <div id="trim_image" class="d-lg-block d-none col-6">
              <img
                class="me-2"
                src="@/assets/img/ui/plcnext_pfeile.svg"
                alt="PLCNext arrows logo"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <slot />
  </profile>
</template>

<script lang="ts" setup>
import Profile from "~/components/shared/layout/profile.vue";
import { useUserStore } from "~/stores/userstore";
import {
  PhUser,
  PhEnvelope,
  PhKey,
  PhBell,
  PhBook,
  PhBracketsCurly,
} from "@phosphor-icons/vue";
import type { Component } from "vue";

const userStore = useUserStore();

const options = computed(() => {
  const base = `/users/${userStore.authUserUuid}/profile`;

  const baseOptions: { name: string; link: string; icon: Component }[] = [
    {
      name: "Profile",
      link: base,
      icon: PhUser,
    },
    {
      name: "Email",
      link: `${base}/email`,
      icon: PhEnvelope,
    },
    {
      name: "Password",
      link: `${base}/password`,
      icon: PhKey,
    },
    {
      name: "Notifications",
      link: `${base}/notifications`,
      icon: PhBell,
    },
  ];

  if (userStore.userWantsToBecomeDeveloper) {
    baseOptions.push({
      name: "Become Developer",
      link: `${base}/become-developer`,
      icon: PhEnvelope,
    });
  }

  baseOptions.push({
    name: "Journal",
    link: `${base}/journal`,
    icon: PhBook,
  });

  baseOptions.push({
    name: "API Access",
    link: `${base}/api_access`,
    icon: PhBracketsCurly,
  });

  return baseOptions;
});

const getFirstNameAndLastName = () => {
  if (userStore.authUser) {
    if (userStore.authUser.firstName && userStore.authUser.lastName) {
      return userStore.authUser.firstName + " " + userStore.authUser.lastName;
    }
    return userStore.authUser.userName;
  }
  return "";
};
</script>
<!-- does not work with scoped because the template is defined in profile.vue layout -->
<style lang="scss">
@use "@/sass/layouts/UserProfile.scss" as *;
</style>
